






















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import { Carater } from '@/types/interfaces/Solicitacao'
import { timeoutDefault, timeout, groupCollectionByField, maskHour, onlyNumber } from '@/utils/common'
import { CancelarSolicitacaoParam, TipoOrigemEnum, TipoUsuarioEnum, PendenciaMensagem, TipoMensagemEnum, TipoDocumentoUpload, StatusAutorizacaoEnum, AutorizacaoSolicitacaoQuery, SolicitacaoAcoesBackofficeEnum, SituacaoEnum, Procedimento } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalAutorizarProcesso extends Vue {
  temQuantidadeAutorizada(grupoOpme: any) {
    const truthyValues: boolean[] = []
    grupoOpme.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        // eslint-disable-next-line
        truthyValues.push(opme.hasOwnProperty('quantidadeAutorizada'))
      })
    })
    return truthyValues.some((e: boolean) => e === true)
  }

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  $refs!: {
    pendenciaAutorizar: any,
    autorizacaoFinalizar: any,
    procedimentoAutorizarQuantidade: any,
    procedimentoInternacaoAutorizarQuantidade: any,
    backofficeSuprimentos: any,
  }

  get hospitalBlumenau() {
    const { solicitacao } = this.getBackofficeGlobalStore
    if (solicitacao && solicitacao.hospital && !!solicitacao.hospital.nome) return solicitacao.hospital.nome === 'Hospital Santa Catarina Blumenau'
    return false
  }

  get btnConfirmText() {
    if (this.step === 1 && this.getBackofficeGlobalStore.solicitacao.hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada) {
      return 'avançar'
    }
    return this.getPendenciaStore.pendencia.mensagens.length > 0 ? 'confirmar pendência' : 'confirmar'
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: false,
    anexoOperadora: false,
    guiaAutorizacaoDoRoboAutorizacao: true,
    resumo: true,
  }

  step: number = 1
  modalPendencia: boolean = false
  modalConfirmarPendencia: boolean = false
  loadComentarios: boolean = false
  loadHistorico: boolean = false
  loadPendencia: boolean = false
  loadCancelamento: boolean = false
  loadClose: boolean = false
  loadConfirmar: boolean = false
  loadClosePedencia: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  showModalConfirmacaoWhatsApp: boolean = false
  loadingEnvioWhatsApp: boolean = false

  mensagem: string = ''
  inputFiles: any[] = []

  headers: any[] = [
    { text: 'Procedimento', class: 'table-headers-email', align: 'left', value: 'procedimento', sortable: false },
    { text: 'Solicitada', class: 'table-headers-email', align: 'left', value: 'solicitada', sortable: false },
    { text: 'Autorizada', class: 'table-headers-email', align: 'left', sortable: false },
  ]

  quantidadeRules: any = {
    valid: true,
    quantidade: [v => !!v || 'Campo obrigatório.'],
  }

  unlocked: boolean = false

  get getProcedimentos() {
    const a = this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados ? this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados : []
    return [this.getBackofficeGlobalStore.solicitacao.procedimento, ...a]
  }

  get getProcedimentosInternacao() {
    return this.getBackofficeGlobalStore.solicitacao.procedimentosInternacao
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.pacienteNome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get showModalAutorizaProcesso() {
    const show = this.getBackofficeGlobalStore.modal.autorizarProcesso
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalAutorizaProcesso(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'autorizarProcesso', value: val })
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }

  @Watch('showModalAutorizaProcesso')
  onChangeShowModalAutorizaProcesso(value) {
    const { quantidadeAutorizada } = this.$refs.backofficeSuprimentos.$refs
    if (value === false && quantidadeAutorizada && quantidadeAutorizada.length > 0) {
      quantidadeAutorizada.forEach((e: any) => {
        e.resetValidation()
        e.reset()
      })
    }
    this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.resetValidation()
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll-top-autorizar-processo')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async closeModalBtn() {
    if (this.getBackofficeGlobalStore.valorNegociadoLoading) return
    this.loadingClose = true
    await timeoutDefault()
    await this.closeModal()
    this.loadingClose = false
  }

  async finalizarAutorizacao() {
    this.loadingConfirmar = true

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingConfirmar = false
      return false
    }

    if (this.temNaoInformadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'informado'
      this.loadingConfirmar = false
      return false
    }

    if (this.temNaoHomologadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'homologado'
      this.loadingConfirmar = false
      return false
    }

    const {
      protocoloOPME,
      protocoloOperadora,
      autorizacaoValidade,
      dataAutorizacaoNaOperadora,
      autorizacaoObservacao,
      operadoraSenha,
      operadoraSenhaProvisoria,
      operadoraQuantidadeDiasAutorizado,
      statusAguardandoOperadora,
    } = this.getBackofficeGlobalStore.solicitacao

    const body: any = {
      protocoloOPME,
      protocoloOperadora,
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      statusAutorizacao: statusAguardandoOperadora,
      autorizacaoValidade,
      dataAutorizacaoNaOperadora,
      autorizacaoObservacao,
      operadoraSenha,
      operadoraSenhaProvisoria,
      operadoraQuantidadeDiasAutorizado,
      motivoCancelamentoDaSolicitacaoId: this.getSolicitacaoCancelamentoStore.motivo,
    }

    Object.entries(body).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, 0, undefined].includes(value)) {
        delete body[key]
      }
    })

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === SituacaoEnum.EmAnalise) {
      if (this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.validate()) {
        const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

        if (response.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Autorização em análise.', icon: 'done', color: '#2E7D32' })
          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
        }
      }

      this.loadingConfirmar = false
      return false
    }

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === SituacaoEnum.AutorizacaoPos) {
      const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação colocada em Autorização Pós.', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
      }

      this.loadingConfirmar = false
      return false
    }

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === SituacaoEnum.Cancelada) {
      if (!['', null, undefined].includes(this.getSolicitacaoCancelamentoStore.motivo)) {
        const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

        if (response.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação de cancelamento efetuada com sucesso.', icon: 'done', color: '#2E7D32' })
          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema no cancelamento da solicitação..', icon: 'warning', color: '#C62828' })
        }
      }
    }

    if (this.getBackofficeGlobalStore.solicitacao.hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada) {
      if (this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.validate()) {
        this.loadingConfirmar = false
        this.getStep = 2
      }
    } else {
      /* Adicionar essa regra pq são usados somente status de aguardando cotação */
      if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.Autorizada
          && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizadaParcial
          && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizadaAceitaMedico
          && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.Cancelada
          && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.EmAnalise
          && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizacaoPos) {
        this.getBackofficeGlobalStore.setStatusAguardandoOperadora('')
        this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.validate()
        this.loadingConfirmar = false
        return false
      }

      if (!this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.validate()) {
        this.loadingConfirmar = false
        return false
      }

      const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Processo atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false

    return true
  }

  grupoOpmeDaSolicitacao() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        y.push({
          opmeId: x.opmeId,
          tipo: x.tipo,
          codigoHospital: x.codigoHospital,
          fazCotacao: !!x.fazCotacao,
          necessitaDeProfissionalAdicional: !!x.necessitaDeProfissionalAdicional,
          valorUnitario: x.valorUnitario,
        })
        return y
      }, [])

      acc.push({ id: obj.id, opmes })

      return acc
    }, [])
  }

  async finalizarAutorizacaoStepTwo() {
    this.loadingConfirmar = true
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingConfirmar = false
      return false
    }

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.Autorizada
        && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizadaParcial
        && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizadaAceitaMedico
        && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.Cancelada
        && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.EmAnalise
        && this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== SituacaoEnum.AutorizacaoPos) {
      this.getBackofficeGlobalStore.setStatusAguardandoOperadora('')
      this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.validate()
      this.loadingConfirmar = false
      return false
    }
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    const { procedimentoAutorizarQuantidade, backofficeSuprimentos, procedimentoInternacaoAutorizarQuantidade } = this.$refs
    const isValid: boolean = grupoOpmeDaSolicitacao && grupoOpmeDaSolicitacao.length > 0
      ? backofficeSuprimentos.isQuantidadeAutorizadaValid() && procedimentoAutorizarQuantidade.isValid() && (!procedimentoInternacaoAutorizarQuantidade ? true : procedimentoInternacaoAutorizarQuantidade.isValid())
      : procedimentoAutorizarQuantidade.isValid() && (!procedimentoInternacaoAutorizarQuantidade ? true : procedimentoInternacaoAutorizarQuantidade.isValid())

    if (isValid) {
      const {
        protocoloOPME,
        protocoloOperadora,
        autorizacaoValidade,
        dataAutorizacaoNaOperadora,
        autorizacaoObservacao,
        operadoraSenha,
        operadoraSenhaProvisoria,
        operadoraQuantidadeDiasAutorizado,
      } = this.getBackofficeGlobalStore.solicitacao

      const body: any = {
        protocoloOPME,
        protocoloOperadora,
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        statusAutorizacao: this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora,
        autorizacaoValidade,
        dataAutorizacaoNaOperadora,
        autorizacaoObservacao,
        operadoraSenha,
        operadoraSenhaProvisoria,
        operadoraQuantidadeDiasAutorizado,
        motivoCancelamentoDaSolicitacaoId: this.getSolicitacaoCancelamentoStore.motivo,
        autorizacaoInformaQuantidadeAutorizada: {
          procedimentoPrincipal: {
            procedimentoId: this.getProcedimentos[0] ? this.getProcedimentos[0].id : '',
            quantidadeAutorizada: this.getProcedimentos[0] ? this.getProcedimentos[0].quantidadeAutorizada : '',
            observacaoDaAutorizacao: this.getProcedimentos[0] ? this.getProcedimentos[0].observacaoDaAutorizacao : '',
          },
          procedimentosAssociados: this.getProcedimentos.reduce((acc: any, next: any) => {
            if (next && !next.procedimentoPrincipal) {
              acc.push({
                procedimentoId: next.id,
                quantidadeAutorizada: next.quantidadeAutorizada,
                observacaoDaAutorizacao: next.observacaoDaAutorizacao || '',
              })
            }
            return acc
          }, []),
          procedimentosInternacao: this.getProcedimentosInternacao.reduce((acc: any, next: any) => {
            if (next) {
              acc.push({
                procedimentoId: next.id,
                quantidadeAutorizada: next.quantidadeAutorizada,
              })
            }
            return acc
          }, []),
          grupoOpmes: this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
            const opmes = obj.opmes.reduce((y: any, x: any) => {
              y.push({
                opmeId: x.opmeId,
                valorUnitario: x.valorUnitario,
                quantidadeAutorizada: x.quantidadeAutorizada,
                statusDaAutorizacao: x.statusDaAutorizacao,
                observacaoDaAutorizacao: x.observacaoDaAutorizacao,
              })
              return y
            }, [])

            acc.push({ id: obj.id, opmes })
            return acc
          }, []),
        },
      }

      Object.entries(body).forEach(([key, value]) => {
        // @ts-ignore
        if (['', null, 0, undefined].includes(value)) {
          delete body[key]
        }
      })

      const response = await this.autorizacao.enviarGuias({
        acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar,
        body,
      })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Autorização efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao efetuar a autorização.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false

    return true
  }

  async autorizacaoSolicitaCancelamento() {
    await this.showModalCancelamentoBase()
    this.loadingConfirmar = false
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await this.showModalCancelamentoBase()
    this.loadingCancelamento = false
  }

  async showModalCancelamentoBase() {
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'autorizarProcesso',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
  }

  async closeModalCancelamento() {
    this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.closeModal()
  }

  async closeModal() {
    if (this.getBackofficeGlobalStore.valorNegociadoLoading) return
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const request = await this.autorizacao.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.unlocked = !!request.success

    if (this.getSolicitacaoCancelamentoStore.modal.cancelamentoAutorizacao) {
      this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(false)
    }

    this.getSolicitacaoCancelamentoStore.clear()

    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getStep = 1
    this.loadingClose = false

    this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.reset()
    this.$refs.autorizacaoFinalizar.$refs.autorizacaoForm.resetValidation()

    this.getBackofficeGlobalStore.closeModalAutorizarProcesso()

    /* Confirmar Pendência */
    this.showModalConfirmarPendencia = false
    this.getPendenciaStore.clearPendencia()
  }

  async openModalPendencia() {
    this.loadingPendencia = true
    await timeoutDefault()
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async showModalHistorico() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async addPendenciaMensagem(mensagem: string) {
    await timeoutDefault()
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: mensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.$refs.pendenciaAutorizar.clearMensagem()
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFile(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  openModalConfirmarPendencia() {
    this.showModalConfirmarPendencia = true
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    if (this.unlocked) await this.autorizacao.desbloquearSolicitacao(solicitacaoId)
    this.unlocked = false
    this.loadingConfirmarPendencia = false
  }

  async closeModalConfirmacaoWhatsApp() {
    this.showModalConfirmacaoWhatsApp = false
    await this.confirmarPendencia()
  }

  async confirmarPendenciaComOuSemWhatsApp() {
    const { acoes } = this.getBackofficeGlobalStore.solicitacao

    if (acoes && acoes.exigeConfirmacaoParaEnvioWhatsappNaCriacaoDePendencia === true) {
      this.showModalConfirmacaoWhatsApp = true
    } else {
      await this.confirmarPendencia()
    }
  }

  async confirmarPendenciaComWhatsApp() {
    this.loadingEnvioWhatsApp = true

    const resultado = await this.getBackofficeGlobalStore.enviarNotificacaoWhatsapp('PendenciaAutorizacao')
    if (resultado.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Notificação WhatsApp enviada com sucesso', icon: 'check_circle', color: '#43A047' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao enviar notificação WhatsApp', icon: 'warning', color: '#C62828' })
    }

    this.loadingEnvioWhatsApp = false
    this.showModalConfirmacaoWhatsApp = false

    await this.confirmarPendencia()
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    // EventBus.$on('updateSolicitacao', (value: any) => this.getBackofficeGlobalStore.setFormAutorizacao(value))
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  /**
   * FORNECEDOR NÃO INFORMADO OU NÃO HOMOLOGADO
   */

  modalConfirmarFornecedor: boolean = false
  get showModalConfirmarFornecedor() {
    return this.modalConfirmarFornecedor
  }

  set showModalConfirmarFornecedor(value: boolean) {
    this.modalConfirmarFornecedor = value
  }

  loadEditFornecedores: boolean = false

  get loadingEditFornecedores() { return this.loadEditFornecedores }
  set loadingEditFornecedores(value: boolean) { this.loadEditFornecedores = value }

  async openModalEditarFornecedorOPME() {
    this.loadingEditFornecedores = true
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi()
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
      this.showModalConfirmarFornecedor = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditFornecedores = false
  }

  naoInformadoOuNaoHomologadoInput: string = 'informado'
  get naoInformadoOuNaoHomologado() { return this.naoInformadoOuNaoHomologadoInput }
  set naoInformadoOuNaoHomologado(value: string) { this.naoInformadoOuNaoHomologadoInput = value }

  temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }
}
